import {
  GetPlantingQuery,
  ListOrphanedPlantingsQuery,
  GetPlanterRegistrationQuery,
  GetAdminPlantingQuery,
  GetAdminApplicationQuery,
  GetApplicationQuery,
  ListApplicationSeasonPlantingsBySiteQuery,
  ListApplicationSeasonPlantingsQuery
} from 'src/config/generated/graphql'

import { ArrayElement } from './common'

// GQL types

export type PlantingType = NonNullable<
  ArrayElement<GetPlantingQuery['Planting']>
>

export type AdminPlantingType = NonNullable<GetAdminPlantingQuery['Planting']>

export type PlantingLineType = ArrayElement<
  ArrayElement<NonNullable<GetPlantingQuery['Planting']>>['PlantingLines']
>

export type AdminOrphanedPlantingType = ArrayElement<
  ListOrphanedPlantingsQuery['Planting']
>

export type PlanterRegistrationType = NonNullable<
  GetPlanterRegistrationQuery['planterRegistration']
>

export type AdminApplicationPlantingsType = NonNullable<
  GetAdminApplicationQuery['Application']
>['Plantings']

export type ApplicationPlantingsType = ArrayElement<
  NonNullable<GetApplicationQuery['Application']>
>['Plantings']

export type ApplicationPlantingType = ArrayElement<ApplicationPlantingsType>

export type ListApplicationSeasonPlantingsBySiteType = ArrayElement<
  ListApplicationSeasonPlantingsBySiteQuery['Application']
>['PlantingSites']

export type ListApplicationSeasonPlantingsType = ArrayElement<
  ListApplicationSeasonPlantingsQuery['Application']
>['Plantings']

// Frontend types and enums

export enum PlantingWorkflowState {
  Draft = 'Draft',
  Submitted = 'Submitted'
}
